module.exports = __webpack_public_path__ + "static/img/12.ea14235.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/12.png
// module id = DD8p
// module chunks = 0